import { baseClasses } from '@weatherbug/common';
import { LegalProvider } from '../providers/legalProvider';

const { AsyncAction } = baseClasses;
export const GET_COMPLIANCE_REQUIREMENTS_V3 = new AsyncAction('GET_COMPLIANCE_REQUIREMENTS_V3');

export const GET_LEGAL_POLICIES = 'GET_LEGAL_POLICIES';
export const GET_LEGAL_POLICIES_FULFILLED = 'GET_LEGAL_POLICIES_FULFILLED';
export const GET_LEGAL_POLICIES_REJECTED = 'GET_LEGAL_POLICIES_REJECTED';
export const GET_CURRENT_LEGAL_POLICIES = 'GET_CURRENT_LEGAL_POLICIES';
export const GET_CURRENT_LEGAL_POLICIES_FULFILLED = 'GET_CURRENT_LEGAL_POLICIES_FULFILLED';
export const GET_CURRENT_LEGAL_POLICIES_REJECTED = 'GET_CURRENT_LEGAL_POLICIES_REJECTED';

export function getLegalPolicies(touVersion, ppVersion, countrycode, languagecode, baseUrl, authId, secret, stdParameters)
{
    return {
        type: GET_LEGAL_POLICIES,
        payload: _getLegalPolicies(touVersion, ppVersion, countrycode, languagecode, baseUrl, authId, secret, stdParameters)
    };
}

async function _getLegalPolicies(touVersion, ppVersion, countrycode, languagecode, baseUrl, authId, secret, stdParameters) {
    const op = new LegalProvider(baseUrl, authId, secret);
    return await op.getLegalPolicies(touVersion, ppVersion, countrycode, languagecode, stdParameters);
}

export function getCurrentLegalPolicies(baseUrl, authId, secret, countrycode, languagecode, stdParameters)
{
    return {
        type: GET_CURRENT_LEGAL_POLICIES,
        payload: _getCurrentLegalPolicies(baseUrl, authId, secret, countrycode, languagecode, stdParameters)
    };
}

async function _getCurrentLegalPolicies(baseUrl, authId, secret, countrycode, languagecode, stdParameters) {
    const op = new LegalProvider(baseUrl, authId, secret);
    return await op.getCurrentLegalPolicies(countrycode, languagecode, stdParameters);
}

export function getComplianceRequirementsV3(baseUrl, authId, secret, stdParameters, ipAddress)
{
    return {
        type: GET_COMPLIANCE_REQUIREMENTS_V3.base,
        payload: _getComplianceRequirementsV3(baseUrl, authId, secret, stdParameters, ipAddress)
    };
}

async function _getComplianceRequirementsV3(baseUrl, authId, secret, stdParameters, ipAddress) {
    const op = new LegalProvider(baseUrl, authId, secret);
    return await op.getComplianceRequirementsV3(stdParameters, ipAddress);
}
